// extracted by mini-css-extract-plugin
export default {"color-content":"SerialInfo_color-content__6L+x1"};